//Trump properties
var allTypesVisas = ["Total", "Intracompany transfers (L1)", "Extraordinary ability workers (O1)", "Agricultural workers (H2A)", "Temporary workers (H1B)"];

//Parses date for correct time format
var parseDate = d3.time.format("%Y").parse;

//Loads the data
d3.csv("data/visas2.csv", ready);

function ready(err, data) {

  if (err) throw "error loading data";

  //FORMAT data
  data.forEach(function(d) {
    d.count = +d.count;
    d.year = parseDate(d.year);
  });

  //Map the property names to the data
  allTypesVisas = d3.set(data.map(function(d) { return d.type; })).values();

  allTypesVisas = allTypesVisas.filter(function(d) { return d != "Total"});

  //Organizes the data
  //data.sort(function(a,b) { return a.year - b.year; });
  var maxY = d3.max(data, function(d) { return d.count; });
  var maxX = d3.max(data, function(d) { return d.year; });
  var minX = d3.min(data, function(d) { return d.year; });

  //Make a chart for each property
  var charts = allTypesVisas.map(makeChart);

  d3.select(window).on("resize", function () {
    charts.forEach(function(chart) {
      chart.resize();
    })
  });

  function makeChart(name, chartIndex) {

    //Append individual chart div
    var chartContainer = d3.select(".gia-chart").append("div")
      .attr("class", "g-chart-container");

    //Margin conventions
    var margin = {top: 5, right: 5, bottom: 15, left: 33};

    var widther = d3.select(".g-chart-container").node().clientWidth;

    var width = (widther) - margin.left - margin.right,
      height = 200 - margin.top - margin.bottom;

    //Creates the xScale
    var xScale = d3.time.scale()
      .range([0, width]);

    //Creates the yScale
    var yScale = d3.scale.linear()
      .range([height, 0]);

    //line function convention (feeds an array)
    var line = d3.svg.line()
      .x(function(d) { return xScale(d.year); })
      .y(function(d) { return yScale(d.count); });

    //area function
    var area = d3.svg.area()
      .x(function(d) {return xScale(d.year); })
      .y0(height)
      .y1(function(d) {return yScale(d.count); });

    //Defines the xScale max
    xScale.domain(d3.extent(data, function(d) { return d.year; }));

    //Defines the yScale max
    yScale.domain([0, 200000]);

    //Defines the y axis styles
    var yAxis = d3.svg.axis()
      .scale(yScale)
      .tickSize(-width)
      .tickPadding(6)
      .ticks(5)
      .orient("left")
      .tickFormat(function(d) { return d/1000 + "k"});

    //Defines the y axis styles
    var xAxis = d3.svg.axis()
      .scale(xScale)
      .tickPadding(0)
      .orient("bottom")
      .tickValues([minX, maxX])
      .tickFormat(d3.time.format("%Y"));

    //Finds the data associated with each property name
    var myTypeName = name;

    var myTypeData = data.filter(function(d) {
      return d.type === myTypeName;
      return d.code === myTypeCode;
    });

    myTypeData = myTypeData.filter(function(d) { return d.type != "Total"})

    //Sets value for ending dot on line
    var maxXdot = d3.max(myTypeData, function(d) { return d.year; });

    var typeName = d3.max(myTypeData, function(d) { return d.state; });
    var typeCode = d3.max(myTypeData, function(d) { return d.code; });

    //Appends chart heading div
    var chartHeading = chartContainer.append("div")
      .attr("class", "g-heading");  

    //Appends the property name to the individual chart container
    var chartLocation = chartHeading.append("h5")
      .attr("class", "g-property");  

    //Appends the property chart to the individual chart container
    var chart = chartContainer.append("div")
      .attr("class", "g-chart");

    //Assigns the property name
    chartLocation.text(myTypeName);

    //Appends the svg to the chart-container div
    var svg = chart.append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom)
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    //Appends the y axis
    var yAxisGroup = svg.append("g")
      .attr("class", "y axis")
      .call(yAxis)
      .selectAll("g")
      .classed("g-baseline", function(d) {return d == 0});

    //Appends the x axis
    var xAxisGroup = svg.append("g")
      .attr("class", "x axis")
      .attr("transform", "translate(0," + height + ")")
      .call(xAxis)
      .selectAll("g")
      .classed("g-start", function(d) {return d == minX})
      .classed("g-end", function(d) {return d == maxX});

      d3.selectAll('.y.axis text')
        .attr("transform", "translate(-27,0)");


    //Binds the data to the area
    var drawarea = svg.append("path")
      .datum(myTypeData)
      .attr("class", "area")
      .attr("d", area);

    //Binds the data to the line
    var drawline = svg.append("path")
      .datum(myTypeData)
      .attr("class", "line")
      .attr("d", line)
      .selectAll("line");  

    //Adding circle label
    var labelElements = svg.append("g")
      .attr("class", "fiddly-bits")

    var label = labelElements.selectAll(".g-label-element")
      .data(myTypeData.filter(function(d) { return d.year == maxXdot; }))
      .enter().append("g")
      .attr("class", function(d, i) { return 'g-label-element'+i;})
      .attr("transform", function(d) { return "translate(" + xScale(d.year) + "," + yScale(d.count) + ")"; } );

    label.append("circle")
      .attr("r", 3)
      .attr("class", "g-label-circle");  

    if(chartIndex == 0) {
      d3.select(".line")
        .attr("class", "line-H1"); 

      d3.select(".area")
        .attr("class", "area-H1");  

      d3.select(".g-label-circle")  
        .attr("class", "g-label-circle-H1")
    }    

    return {
      resize: function () {
        //new margin
        var newMargin = {top: 5, right: 5, bottom: 15, left: 33};

        var newWidther = d3.select(".g-chart-container").node().clientWidth;

        var newWidth = (newWidther) - newMargin.left - newMargin.right;

        //Change the width of the svg
        d3.selectAll("svg")
          .attr("width", newWidth + newMargin.left + newMargin.right);

        //Change the xScale
        xScale
          .range([0, newWidth]);

        //Update the lines
        line = d3.svg.line()
          .x(function(d) { return xScale(d.year); })
          .y(function(d) { return yScale(d.count); });

        d3.selectAll('.line')
          .attr("d", line);

        d3.selectAll('.line-H1')
          .attr("d", line);  

        //Update the area
        area = d3.svg.area()
          .x(function(d) {return xScale(d.year); })
          .y0(height)
          .y1(function(d) {return yScale(d.count); });

        d3.selectAll('.area')
          .attr("d", area);

        d3.selectAll('.area-H1')
          .attr("d", area);    

        //Updates label
        d3.selectAll('.g-label-element0')
          .attr("transform", function(d) { return "translate(" + xScale(d.year) + "," + yScale(d.count) + ")"; } );

        //Updates xAxis
        d3.selectAll(".x.axis")
          .call(xAxis);

        xAxis
          .scale(xScale);

        //Updates yAxis
        d3.selectAll(".y.axis")
          .call(yAxis);

        yAxis
          .tickSize(-newWidth);

        //Updates overlay
        d3.selectAll(".overlay")
          .attr("width", newWidth);
      }
    };
  }
}